import React, { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment-timezone";
import {
    selectOrders,
    setOrders,
    selectDoctorCompany,
    setOrder,
    selectOrder,
    setShowOrderCard,
    selectShowOrderCard,
    selectBackNavigationTick,
    setPacient,
    setPaid,
    setTechnicId,
    setPrice,
    setColor,
    setPhotos,
    setAudios,
    setComments,
    selectPacient,
    selectColor,
    selectPrice,
    selectPaid,
    selectTypePaid,
    selectTechnicId,
    selectDoctorName
} from "./orderSlice";
import "./Orders.css";
import { getOrderAudios, getOrderComments, getOrderPhotos, getUserOrders, saveOrderCard } from "./orderApi";
import { 
    selectDoctorId, 
    selectUserId,
    selectCompany,
    selectBankName,
    selectBik,
    selectCheckingAccount,
    selectCorrespondentAccount,
    selectInn,
    selectKpp
} from "../../Login/loginSlice";
import OrderCard from "./orderCard";
import { getTechnics } from "../labApi";
import { setTechnics } from "../labSlice";
import DoctorInfo from "./doctorInfo";
import OrdersHeader from "./ordersHeader";
import OrderItem from "./orderItem";
import ActTable from "./ActTable";
import InvoiceTable from "./InvoiceTable";

const Orders = ({ doctorId }) => {
    const dispatch = useDispatch();
    const orders = useSelector(selectOrders);
    const order = useSelector(selectOrder)
    const userId = useSelector(selectUserId);
    const doctorCompany = useSelector(selectDoctorCompany);
    const showOrderCard = useSelector(selectShowOrderCard);
    const backNavigationTick = useSelector(selectBackNavigationTick);
    const doctor_id = useSelector(selectDoctorId)
    const pacient = useSelector(selectPacient);
    const color = useSelector(selectColor);
    const price = useSelector(selectPrice);
    const paid = useSelector(selectPaid);
    const type_pay = useSelector(selectTypePaid);
    const technic_id = useSelector(selectTechnicId);
    const doctor_name = useSelector(selectDoctorName) //|| useSelector(selectRoleDoctorName)

    const user_id = useSelector(selectUserId)
    
    // Банковские реквизиты из настроек
    const companyName = useSelector(selectCompany);
    const bankName = useSelector(selectBankName);
    const bik = useSelector(selectBik);
    const checkingAccount = useSelector(selectCheckingAccount);
    const correspondentAccount = useSelector(selectCorrespondentAccount);
    const inn = useSelector(selectInn);
    const kpp = useSelector(selectKpp);

    const [isLoading, setIsLoading] = useState(false);
    const profession = "Врачи"; // Константа для профессии
    const [dateDelivery, setDateDelivery] = useState(null)
    const [allDebet, setAllDebet] = useState(0)
    const [is_pay, setIs_pay] = useState('all');
    const [hasCustomPrices, setHasCustomPrices] = useState(false)
    const [stringFind, setStringFind] = useState('')
    const [findArray, setFindArray] = useState([])
    const [selectForAct, setSelectForAct] = useState(false)
    const [selectForInvoice, setSelectForInvoice] = useState(false)
    const [selectedOrders, setSelectedOrders] = useState([])
    const [selectedMonth, setSelectedMonth] = useState('')
    const [preShowAct, setPreShowAct] = useState(false)
    const [preShowInvoice, setPreShowInvoice] = useState(false)

    const prevBackTick = useRef(backNavigationTick);

    const saveOrderFields = useCallback(() => {
        saveOrderCard(
            {
                order_id: order.id,
                pacient: pacient,
                color: color,
                price: price,
                paid: paid,
                type_pay: type_pay,
                date_delivery: dateDelivery
                    ? moment(dateDelivery).tz("Europe/Moscow").format("YYYY-MM-DD HH:mm:ss")
                    : '',

                technic_id: technic_id
            }, (data) => {
                getUserOrders({ user_id: user_id, profession: profession, doctor_id: doctor_id }, (data) => {
                    dispatch(setOrders(data.orders))
                    const all_debet = data.orders.reduce((a, v) => a + v.price - v.paid, 0)
                    setAllDebet(all_debet)
                })
            })

        dispatch(setShowOrderCard(false))
    }, [order, pacient, color, price, paid, type_pay, dateDelivery, technic_id, user_id, profession, doctor_id, dispatch]);

    const handleBackToOrdersList = useCallback(() => {
        dispatch(setOrder(null));
        dispatch(setPacient(''));
        dispatch(setPaid(''));
        dispatch(setTechnicId(''));
        dispatch(setPrice(''));
        dispatch(setColor(''));
        dispatch(setShowOrderCard(false));
        saveOrderFields();
    }, [dispatch, saveOrderFields]);

    useEffect(() => {
        if (backNavigationTick === prevBackTick.current) return;
        prevBackTick.current = backNavigationTick;
        if (showOrderCard) {
            handleBackToOrdersList();
        }
    }, [backNavigationTick, showOrderCard, handleBackToOrdersList]);



    const refreshOrders = () => {
        getUserOrders({ user_id: user_id, profession: profession, doctor_id: doctor_id }, (data) => {
            const all_debet = data.orders.reduce((a, v) => a + v.price - v.paid, 0)
            setAllDebet(all_debet)
            dispatch(setOrders(data.orders))
        })
    }

    const handleFind = (text) => {
        let new_find_array = findArray.slice()
        for (let i = 0; i < orders.length; i++) {
            if (orders[i]?.pacient.toLowerCase().indexOf(text.toLowerCase()) !== -1) {
                new_find_array[i] = 1
            }
            else new_find_array[i] = 0
        }
        setFindArray(new_find_array)
        setStringFind(text)
    }

    // Обработчики для работы с актами
    const handleGenerateAct = () => {
        setPreShowAct(true);
    };

    // Обработчики для работы со счетами
    const handleGenerateInvoice = () => {
        setPreShowInvoice(true);
    };

    const handleSelectAllOrders = () => {
        const allOrderIds = orders.map(order => order.id);
        
        // Проверяем, все ли заказы уже выбраны
        const allSelected = allOrderIds.every(id => selectedOrders.includes(id));
        
        if (allSelected) {
            // Если все выбраны - снимаем выделение со всех
            setSelectedOrders([]);
        } else {
            // Если не все выбраны - выбираем все
            setSelectedOrders(allOrderIds);
        }
    };

    const handleSelectMonth = (month) => {
        setSelectedMonth(month);
        // TODO: Реализовать выбор заказов за месяц
        console.log('Выбран месяц:', month);
    };

    const handleSelectOrder = (orderId) => {
        setSelectedOrders(prev => 
            prev.includes(orderId) 
                ? prev.filter(id => id !== orderId)
                : [...prev, orderId]
        );
    };

    const handleOrderClick = (order) => {
        dispatch(setOrder(order));
        dispatch(setPacient(order.pacient));
        dispatch(setPaid(order.paid));
        dispatch(setTechnicId(order.technic_id));
        dispatch(setPrice(order.price));
        dispatch(setColor(order.color));

        getOrderPhotos({ order_id: order.id }, (data) => {
            dispatch(setPhotos(data.photos));
        });

        getOrderAudios({ order_id: order.id }, (data) => {
            dispatch(setAudios(data.audios));
        });

        getOrderComments({ order_id: order.id }, (data) => {
            dispatch(setComments(data.comments));
        });

        dispatch(setShowOrderCard(true));
    };

    useEffect(() => {
        setIsLoading(true);
        getUserOrders(
            { user_id: userId, profession, doctor_id: doctorId },
            (data) => {
                setIsLoading(false);
                if (data && data.orders) {
                    console.log('data.orders', data.orders)
                    dispatch(setOrders(data.orders));
                }
            }
        );

    }, [userId, profession, doctorId, dispatch]);

    useEffect(() => {
        getTechnics({ user_id: userId }, (res) => {
            console.log('getTechnics', res)
            dispatch(setTechnics(res.technics))
        })
    }, [dispatch, userId]);

    // Инициализация findArray при изменении orders
    useEffect(() => {
        if (orders.length > 0) {
            const initialFindArray = new Array(orders.length).fill(1);
            setFindArray(initialFindArray);
        }
    }, [orders]);

    // Если включен режим карточки — показываем OrderCard
    if (showOrderCard) {
        return (
            <div className="orders-container">
                <OrderCard dateDelivery={dateDelivery} setDateDelivery={setDateDelivery} />
            </div>
        );
    }

    // Если заказ не выбран → показываем список
    return (
        <div className="orders-container">
            <div className="orders-header">
                <DoctorInfo
                    doctorName={doctor_name}
                    doctorCompany={doctorCompany}
                    allDebet={allDebet}
                    is_pay={is_pay}
                    setIs_pay={setIs_pay}
                    hasCustomPrices={hasCustomPrices}
                    setHasCustomPrices={setHasCustomPrices}
                    selectForAct={selectForAct}
                    setSelectForAct={setSelectForAct}
                    selectForInvoice={selectForInvoice}
                    setSelectForInvoice={setSelectForInvoice}
                    selectedOrders={selectedOrders}
                    setSelectedOrders={setSelectedOrders}
                    onGenerateAct={handleGenerateAct}
                    onGenerateInvoice={handleGenerateInvoice}
                    onSelectAllOrders={handleSelectAllOrders}
                    onSelectMonth={handleSelectMonth}
                    selectedMonth={selectedMonth}
                    orders={orders}
                />
            </div>

            <div className="search-container">
                <input
                    type="text"
                    className="search-input"
                    value={stringFind}
                    onChange={(e) => handleFind(e.target.value)}
                    placeholder="Поиск по пациентам"
                />
            </div>

            <div className="divider"></div>

            <OrdersHeader doctorCompany={doctorCompany} profession={profession} />


            {isLoading ? (
                <p className="loading-text">Загрузка заказов...</p>
            ) : orders.length === 0 ? (
                <p className="empty-text">Заказов пока нет</p>
            ) : (
                <div className="orders-list">
                    {orders
                        .filter((order, index) => {
                            // Фильтр по статусу оплаты
                            let paymentFilter = false;
                            if (is_pay === "all") paymentFilter = true;
                            else if (is_pay === "debt") {
                                paymentFilter = order.price - order.paid > 0 || order.price === 0;
                            }
                            else if (is_pay === "paid") {
                                paymentFilter = order.price - order.paid <= 0 && order.price !== 0;
                            }

                            // Фильтр по поиску
                            let searchFilter = true;
                            if (stringFind && findArray[index] !== 1) {
                                searchFilter = false;
                            }

                            return paymentFilter && searchFilter;
                        })
                        .map((order) => (
                            <OrderItem
                                key={order.id}
                                order={order}
                                handleOrderClick={handleOrderClick}
                                refreshOrders={refreshOrders}
                                selectForAct={selectForAct || selectForInvoice}
                                selectedOrders={selectedOrders}
                                onSelectOrder={handleSelectOrder}
                            />
                        ))}
                </div>
            )}

            {/* Модальное окно для счета */}
            {preShowInvoice && (
                <div className="act-modal-overlay" onClick={() => setPreShowInvoice(false)}>
                    <div className="act-modal-content" onClick={(e) => e.stopPropagation()}>
                        <InvoiceTable
                            data={{ headers: ["№", "№ заказа", "ФИО пациента", "Сумма"] }}
                            orders={orders.filter(o => selectedOrders.includes(o.id))}
                            dateDelivery={dateDelivery}
                            doctorName={doctor_name}
                            doctorCompany={doctorCompany}
                            pacient={pacient}
                            companyName={companyName}
                            address={''}
                            inn={inn}
                            kpp={kpp}
                            bankName={bankName}
                            bik={bik}
                            checkingAccount={checkingAccount}
                            correspondentAccount={correspondentAccount}
                            onBack={() => setPreShowInvoice(false)}
                        />
                    </div>
                </div>
            )}

            {/* Модальное окно для акта */}
            {preShowAct && (
                <div className="act-modal-overlay" onClick={() => setPreShowAct(false)}>
                    <div className="act-modal-content" onClick={(e) => e.stopPropagation()}>
                        <ActTable
                            data={{ headers: ["№", "№ заказа", "ФИО пациента", "Сумма"] }}
                            actData={[]}
                            order={order}
                            orders={orders.filter(o => selectedOrders.includes(o.id))}
                            dateDelivery={dateDelivery}
                            doctorName={doctor_name}
                            pacient={pacient}
                            price={price}
                            totalServices={1}
                            totalSum={price}
                            companyName={doctorCompany}
                            onBack={() => setPreShowAct(false)}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Orders;
